<fuse-vertical-navigation *ngIf="navigation" class="dark bg-slate-600 print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation?.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center w-full p-4 pl-6">
            <!-- Logo -->
            <div class="flex items-center justify-center">
                <img class="w-60" src="assets/images/imagenesinicio/nuevoLogoBlanco.png" />
            </div>
        </div>


        <!-- User -->
        <div class="flex flex-col items-center w-full p-4">



            <div class="relative w-[50%]">
                <!-- IMAGEN DE EJEMPLO -->
                <img class="w-full h-full rounded-lg border border-4 border-slate-200" [src]="
                        _shared?.datosUser?.imagenS3Link !== null &&
                        _shared?.datosUser?.imagenS3Link !== undefined &&
                        _shared?.datosUser?.imagenS3Link !== ''
                            ? _shared?.datosUser?.imagenS3Link
                            : userImage
                    " alt="User avatar" />
            </div>
            <div class="flex flex-col items-center justify-center w-full mt-6">
                <div
                    class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
                    {{ _shared?.datosUser?.nombre }}
                    {{ _shared?.datosUser?.apellidoPaterno }}
                    {{ _shared?.datosUser?.apellidoMaterno }}
                </div>
                <div
                    class="w-full mt-0.5 whitespace-nowrap text-primary text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                    {{ _shared?.datosUser?.correo }}
                </div>
            </div>
        </div>
    </ng-container>

</fuse-vertical-navigation>

<div class="flex flex-col flex-auto w-full min-w-0">

    <div class="sticky top-0 z-40 flex flex-col w-full h-12 shadow dark:shadow-none print:hidden">

        <div *ngIf="mostrarAlertaInternet"
            class="absolute inset-0 z-50 flex items-center w-full h-full px-4 bg-red-600 text-white animate-fade-in">
            <mat-icon class="mr-2 text-white">signal_wifi_off</mat-icon>
            <div class="flex-auto font-bold text-sm uppercase">
                {{ "ERROR_SIN_INTERNERT" | translate }}
            </div>
            <button mat-icon-button (click)="cerrarAlerta()">
                <mat-icon class="text-white">close</mat-icon>
            </button>
        </div>

        <div class="flex items-center w-full h-full px-4 md:px-6 bg-card dark:bg-transparent border-b">

            <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>

            <!-- <div *ngIf="entorno === 'Test-Pruebas'" class="text-sm font-bold">
                ⚠️ AMBIENTE DE DESARROLLO
            </div>
            <div *ngIf="entorno === 'Integración'" class="text-sm font-bold">
                ⚠️ AMBIENTE DE PRUEBAS
            </div> -->


            <div class="flex-auto"></div>

            <div class="flex items-center space-x-1 sm:space-x-2">
                <notifications></notifications>
                <user></user>
            </div>
        </div>
    </div>

    <div class="flex flex-col flex-auto">
        <router-outlet></router-outlet>
    </div>
</div>
